import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { OptiService } from '../opti.service';
import * as optiActions from './opti.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import * as rootActions from '../../state/app.actions';
import * as fromRoot from '../../state/app.reducer';
import { OptiData } from '../../_models/opti_data';
import { OptiPiece } from '../../_models/opti_piece';

@Injectable()
export class OptiEffects {

	// ----------------------------------
    // 	GUARDAR DATOS PIEZAS OPTIMIZADAS
    // ----------------------------------
    /* // NOTA: Si queremos mostrar ventanas de información tras la acción.
    @Effect()
    saveOptiPiece$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.SaveOptiPiece),
        mergeMap((action: fileActions.SaveOptiPiece) => {
                this.changingLoading(true);
                // console.log('-->... Payload SaveOptiPiece =');
                // console.log(action.payload);

                return this.fileService.saveOptiPiece(action.payload).pipe(
                    map((file: any) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server SaveOptiPiece =');
                        // console.log(file);
                        if (file !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new fileActions.SaveOptiPieceSuccess(file);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new fileActions.SaveOptiPieceFail('ERROR CreateFile effect.');
                        }
                    }),
                    catchError(err => of(new fileActions.SaveOptiPieceFail(err)))
                )
            }
        )
    ); // */

    // NOTA: sin usar Loading ni ventanas de información.
    @Effect()
    saveOptiPiece$ = this.actions$.pipe(
        ofType(optiActions.OptiActitonTypes.SaveOptiPiece),
        map((action: optiActions.SaveOptiPiece) => action.payload),
        mergeMap(( data: any) =>
            //this.fileService.saveOptiPiece(data).pipe(
                this.optiService.saveOptiPiece(data).pipe(
            map((saveOptiPiece: any) => {
                console.log('-->... Payload server SaveOptiPiece =');
                console.log(saveOptiPiece);
                if (saveOptiPiece !== null) {
                    this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                    return new optiActions.SaveOptiPieceSuccess(saveOptiPiece);
                } else {
                    this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                    return new optiActions.SaveOptiPieceFail('ERROR SaveOptiPiece effect.');
                }
                //(new fileActions.SaveOptiPieceSuccess(saveOptiPiece))
            }),
            catchError(err => of(new optiActions.SaveOptiPieceFail(err)))
        ))
    );
    
    // ------- ELIMINAR OPTIMIZACIÓN -------
    
    @Effect()
    deleteOpti$ = this.actions$.pipe(
        ofType(optiActions.OptiActitonTypes.DeleteOpti),
        mergeMap((action: optiActions.DeleteOpti) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteOpti =');
                // console.log(action.payload);

                return this.optiService.deleteOpti(action.payload).pipe(
                    map((optiId: bigint) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server DeleteOpti =');
                        console.log(optiId);
                        if (optiId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new optiActions.DeleteOptiSuccess(optiId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new optiActions.DeleteOptiFail('ERROR DeleteEasel effect.');
                        }
                    }),
                    catchError(err => of(new optiActions.DeleteOptiFail(err)))
                );
            }
        )
    );
    
    // ------- COMPACTAR PILAS -------
    
    @Effect()
    compactOpti$ = this.actions$.pipe(
        ofType(optiActions.OptiActitonTypes.CompactOpti),
        mergeMap((action: optiActions.CompactOpti) => {
                this.changingLoading(true);
                // console.log('-->... Payload compactOpti =');
                // console.log(action.payload);

                return this.optiService.compactOpti(action.payload).pipe(
                    map((opti: any) => {
                        this.changingLoading(false);
                        return new optiActions.CompactOptiSuccess(opti);
                    }),
                    catchError(err => of(new optiActions.CompactOptiFail(err)))
                );
            }
        )
    );
    
    // ----------------------------------
    // 		ESTUDIO DE PRODUCTIVIDAD
    // ----------------------------------
    
    @Effect()
    lotStudy$ = this.actions$.pipe(
        ofType(optiActions.OptiActitonTypes.LotStudy),
        mergeMap((action: optiActions.LotStudy) => {
                this.changingLoading(true);
                // console.log('-->... Payload LotStudy =');
                // console.log(action.payload);

                return this.optiService.lotStudy(action.payload).pipe(
                    map((dataStudy: any) => {
                        this.changingLoading(false);
                        return new optiActions.LotStudySuccess(dataStudy);
                    }),
                    catchError(err => of(new optiActions.LotStudyFail(err)))
                )
            }
        )
    );
    
    @Effect()
    divideLot$ = this.actions$.pipe(
        ofType(optiActions.OptiActitonTypes.DivideLot),
        mergeMap((action: optiActions.DivideLot) => {
                this.changingLoading(true);
                // console.log('-->... Payload DivideLot =');
                // console.log(action.payload);

                return this.optiService.divideLot(action.payload).pipe(
                    map((dataLot: any) => {
                        this.changingLoading(false);
                        return new optiActions.DivideLotSuccess(dataLot);
                    }),
                    catchError(err => of(new optiActions.DivideLotFail(err)))
                )
            }
        )
    );
    
    // ------- OPTIMIZACIONES --------
    
    @Effect()
    loadOpti$ = this.actions$.pipe(
        ofType(optiActions.OptiActitonTypes.LoadOpti),
        mergeMap((action: optiActions.LoadOpti) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadOpti =');
                // console.log(action.payload);

                return this.optiService.getAllOpti(action.payload).pipe(
                    map((opti: OptiData[]) => {
                        this.changingLoading(false);
                        return new optiActions.LoadOptiSuccess(opti);
                    }),
                    catchError(err => of(new optiActions.LoadOptiFail(err)))
                );
            }
        )
    );
    
    @Effect()
    chargeOpti$ = this.actions$.pipe(
        ofType(optiActions.OptiActitonTypes.ChargeOpti),
        mergeMap((action: optiActions.ChargeOpti) => {
                this.changingLoading(true);
                // console.log('-->... Payload ChargeOpti =');
                // console.log(action.payload);

                return this.optiService.chargeOpti(action.payload).pipe(
                    map((opti: OptiPiece[]) => {
                        this.changingLoading(false);
                        return new optiActions.ChargeOptiSuccess(opti);
                    }),
                    catchError(err => of(new optiActions.ChargeOptiFail(err)))
                );
            }
        )
    );
    
    @Effect()
    loadRetalOpti$ = this.actions$.pipe(
        ofType(optiActions.OptiActitonTypes.LoadRetalOpti),
        mergeMap((action: optiActions.LoadRetalOpti) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadRetalOpti =');
                // console.log(action.payload);

                return this.optiService.getRetalOpti(action.payload).pipe(
                    map((opti_pieces: OptiPiece[]) => {
                        this.changingLoading(false);
                        return new optiActions.LoadRetalOptiSuccess(opti_pieces);
                    }),
                    catchError(err => of(new optiActions.LoadRetalOptiFail(err)))
                );
            }
        )
    );

    // ------- CARGA DE LISTADOS PARA SELECTORES --------

  @Effect()
  loadSizes$ = this.actions$.pipe(
    ofType(optiActions.OptiActitonTypes.LoadSizes),
    mergeMap((action: optiActions.LoadSizes) => {
        this.changingLoading(true);
        console.log('-->... Payload LoadSizes =');
        console.log(action.payload);
        return this.optiService.getSizes(action.payload).pipe(
          map((sizes: any) => {
            this.changingLoading(false);
            return new optiActions.LoadSizesSuccess(sizes);
          }),
          catchError(err => of(new optiActions.LoadSizesFail(err)))
        );
      }
    )
  );

    // -----------------------------

    constructor(private actions$: Actions,
                private optiService: OptiService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando opti_prod changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    changingLoading1(value: boolean) {
        console.log('---->>>>.... Ejecutando opti_prod changingLoading1: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading1(value));
    }

    changingLoading2(value: boolean) {
        console.log('---->>>>.... Ejecutando opti_prod changingLoading2: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading2(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: any, skin: string) {
        console.log('---->>>>.... Ejecutando opti_prod Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value, info, link, param, skin }));
    }
}
